import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

const SUPPORTED_LANGUAGES = ['en', 'en-US', 'ja', 'pt', 'pt-BR', 'es', 'es-MX'];

export function isLanguageSupported(language: string = '') {
  return (
    SUPPORTED_LANGUAGES.findIndex(
      (sLanguage) => sLanguage.toLowerCase() === language.toLowerCase(),
    ) > -1
  );
}

export function checkUrlLanguage(language: string) {
  if (isLanguageSupported(language) && language !== i18n.language) {
    i18n.changeLanguage(language);
  }
}

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: SUPPORTED_LANGUAGES,
    fallbackLng: 'en-US',
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    },
    detection: {
      order: [
        'localStorage',
        'sessionStorage',
        'navigator',
        'htmlTag',
        'subdomain',
        'querystring',
        'cookie',
      ],
    },
    debug: false,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;
